import axios from "axios";
import { API_HOST } from "../../consts/api_host";
import { getAccessToken } from "../clients/supabase";
import { getImpersonationHeaders } from "@/features/impersonation/impersonation-session";

type SendPhoneVerificationResponse = {
  success?: boolean;
  error?: string;
};

export const sendPhoneVerification = async (body: {
  phoneNumber: string;
}): Promise<SendPhoneVerificationResponse> => {
  try {
    const response = await axios.post<SendPhoneVerificationResponse>(
      `${API_HOST}/phone/send-verification`,
      body,
      {
        headers: {
          Authorization: `Bearer ${await getAccessToken()}`,
          ...getImpersonationHeaders(),
        },
      },
    );
    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response?.data?.error) {
      return {
        error: e.response.data.error,
      };
    }
    return {
      error: "Error sending verification code. Please try again.",
    };
  }
};
